@if (tpisInfoForm) {
  <form [formGroup]="tpisInfoForm">
    <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
      <h2 dsContent class="bold-header" [contentPath]="headerContentPath"></h2>
      <div>
        <ds-radio-group
          [control]="'tpiOption'"
          [selectedAnswer]=""
          [parentFormGroup]="tpisInfoForm"
          [options]="tpiDescriptionList$ | async"
        >
        </ds-radio-group>
      </div>
      @if (canShowDatePicker) {
        <div class="column twelve md-five">
          <mat-form-field appearance="outline" style="width: 100%">
            <input
              matInput
              [max]="matDatePickerOptions.maxDate"
              [matDatepicker]="picker"
              formControlName="leaseDate"
              readonly
            />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker [dateClass]="dateClass" #picker></mat-datepicker>
            <mat-label>Lease Date</mat-label>
          </mat-form-field>
        </div>
      }
    </div>
    <div class="row column twelve lg-push-two md-eight md-push-two">
      <call-to-action
        [displayBackButton]="true"
        [disabled]="tpisInfoForm.invalid"
        [primaryButtonName]="(isPartner$ | async) ? 'Next Step' : 'Continue'"
        (primaryEvent)="submitTPIsInfo()"
        (backEvent)="goBackOneStep()"
        tertiaryButtonName="Cancel"
        (tertiaryEvent)="cancelEvent.emit(true)"
      ></call-to-action>
    </div>
  </form>
}
